import words from 'lodash-es/words'

/**
 * Default text paragraphs
 */
export const DEFAULT_TEXT = [
  `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec non nulla 
pulvinar, suscipit metus in, ultricies purus. Vivamus augue augue, convallis a
feugiat et, ornare eget leo. Pellentesque et iaculis mi. Praesent ut risus sit
amet diam egestas sodales ut at odio. Cras facilisis lorem ut porttitor
dictum. Aenean eu dui eu nisi tincidunt auctor. Curabitur tristique euismod
est, eget scelerisque massa.`,

  `Nunc varius purus sit amet justo semper, id iaculis urna fermentum. Proin eu
interdum eros. Mauris accumsan varius mollis. Suspendisse diam sapien,
consectetur ut dui sed, suscipit faucibus sapien. Mauris at imperdiet tellus,
vel rhoncus tellus. In eget vehicula libero. Praesent est nibh, hendrerit et
arcu vel, condimentum elementum neque. Pellentesque suscipit lectus nulla, ac
imperdiet urna vestibulum vitae. Ut sed elementum diam.`,

  `Praesent id luctus sapien, in ornare nisl. Vivamus consequat leo sed nisi
lobortis, et pretium velit vehicula. Sed sollicitudin dictum eros quis eleifend.
In mattis nibh at nisi finibus faucibus. Sed commodo arcu id purus commodo
mattis. Phasellus et felis a metus varius molestie. Vestibulum ante ipsum primis
in faucibus orci luctus et ultrices posuere cubilia curae; Quisque tempus
blandit odio, et tincidunt tortor rhoncus ut. Sed tincidunt commodo tellus sed
aliquet. Vivamus vitae commodo urna. Integer efficitur nisi leo, a condimentum
metus pulvinar vel. Interdum et malesuada fames ac ante ipsum primis in
faucibus. Integer tellus lorem, varius ac diam non, tempor tristique justo.
Aenean eu massa vitae purus eleifend maximus. In lorem neque, rutrum eu
fermentum et, viverra eget magna.`,

  `Integer pharetra molestie nulla euismod semper. Integer ultrices ligula vel
tellus fermentum molestie. Ut eu tellus turpis. Pellentesque a tincidunt
purus. Integer semper ligula sit amet dapibus tempus. Praesent in tellus
augue. Pellentesque urna ipsum, pretium in interdum id, maximus quis ipsum.
Quisque non nulla id metus condimentum maximus. Mauris at pulvinar mauris, ac
aliquet quam.`,

  `Praesent sed urna tincidunt, dignissim diam ut, commodo sem. Interdum et
malesuada fames ac ante ipsum primis in faucibus. Proin id magna id nibh sodales
lacinia eu non sem. Vivamus iaculis suscipit enim eget convallis. Orci varius
natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis
condimentum orci ut dui sagittis, in gravida mi euismod. Sed tincidunt erat in
laoreet dignissim. Nam rutrum massa eget suscipit feugiat. Nunc varius non eros
ac ullamcorper. Duis viverra nunc risus, ac lobortis nunc viverra quis. Maecenas
accumsan sem massa, quis pretium augue auctor ac. Proin sagittis venenatis odio
ac sagittis. Nulla aliquet in odio id lobortis. Sed nec ultrices est. Duis nec
aliquam nibh, id hendrerit nisl.`,

  `Cras in neque blandit, ultricies magna in, volutpat sapien. Suspendisse
ornare orci nunc, pellentesque venenatis tellus gravida a. Suspendisse potenti.
Quisque accumsan, enim id rutrum iaculis, massa justo placerat leo, at
vestibulum nisi orci sit amet purus. Proin vulputate ex nisl, sit amet aliquet
mi luctus ac. Praesent lacinia ligula tincidunt pellentesque porttitor. Praesent
in nunc eget velit congue consectetur. Duis placerat hendrerit ipsum, nec dictum
dolor consectetur sit amet. In et diam eu urna dapibus feugiat et eu tortor.
Curabitur ac tortor at elit aliquam tempus feugiat semper dui. In hac habitasse
platea dictumst. Morbi ut dui a velit ultricies lobortis.`,

  `Donec dignissim augue ut dignissim feugiat. Interdum et malesuada fames ac
ante ipsum primis in faucibus. Proin molestie, velit vitae posuere vehicula,
metus arcu rutrum sem, laoreet pharetra augue arcu nec nulla. Cras dictum enim
nec placerat sollicitudin. Duis ac lectus rutrum, dapibus nibh eu, placerat
lectus. Duis ut felis lorem. Praesent vel augue urna. Pellentesque id ipsum
turpis. Sed molestie vehicula orci non pretium. Etiam eu porttitor nulla. Aenean
sit amet dui malesuada nulla faucibus volutpat. Nullam nec dolor ac sem volutpat
ornare. Pellentesque varius nunc nec semper pretium. Morbi a sollicitudin
lectus, ac mattis nunc. Morbi commodo, sem gravida convallis pharetra, ipsum
purus semper odio, nec hendrerit libero sem eu ipsum.`,

  `Duis quis consectetur quam. Suspendisse eu orci a erat dignissim porta.
Aliquam erat volutpat. Cras ultricies quis nisi id mollis. Suspendisse rhoncus,
nulla vitae malesuada lacinia, enim ante auctor odio, ut cursus eros dui vitae
neque. Proin placerat nibh lacus, eget placerat nisl semper egestas. Aliquam
erat volutpat. Cras laoreet tempor leo, non efficitur ante egestas ac. In
malesuada vitae arcu eget consequat. Etiam dictum aliquam ornare. Donec justo
ipsum, posuere id aliquam et, consequat a mi. Aliquam rhoncus malesuada
hendrerit. Class aptent taciti sociosqu ad litora torquent per conubia nostra,
per inceptos himenaeos. Praesent ut mattis purus. In at interdum nunc.`,

  `Vivamus nulla nisi, volutpat ut diam nec, laoreet eleifend nulla. Vestibulum
mattis malesuada lacus, vel ultrices tortor tristique eu. Aliquam nec nunc mi.
Sed lorem ipsum, eleifend eu libero quis, lobortis sodales ante. Ut non ex
dignissim, tincidunt purus vitae, dapibus tellus. Mauris luctus nibh orci,
placerat ornare ante efficitur non. Nulla pharetra cursus neque, in ultrices
massa rutrum facilisis. Nam semper risus sollicitudin luctus porta. Praesent
ullamcorper nibh nisi, vitae malesuada velit sodales quis. Nam iaculis finibus
lacus, eu accumsan quam consequat nec. Maecenas imperdiet malesuada arcu sed
scelerisque. Vivamus nec nibh et justo finibus finibus nec mollis elit. Sed
sapien turpis, ullamcorper sit amet viverra vehicula, feugiat eget turpis.
Suspendisse fermentum eros accumsan tempor posuere. Suspendisse dignissim nisl
ac dolor accumsan, laoreet facilisis risus congue. Cras vitae justo sit amet
ante laoreet fermentum.`,

  `Cras vel mauris faucibus, imperdiet dolor vel, accumsan lacus. Sed vitae elit
vitae augue elementum porttitor sit amet in ligula. Mauris porttitor justo odio,
id consectetur lacus consequat quis. Nullam nec dolor feugiat, pellentesque eros
eu, feugiat leo. Aliquam enim quam, semper at arcu ac, sagittis egestas lorem.
Mauris ultricies non nisl hendrerit posuere. Vestibulum fringilla non dui eget
ornare. Fusce posuere mattis metus, eu sagittis felis gravida efficitur. Sed
iaculis ligula sed metus iaculis gravida. Mauris blandit magna tellus, vitae
tempus erat lacinia vitae. Aenean at odio fringilla magna malesuada volutpat sit
amet ac sapien. Duis sed massa et diam aliquam consequat at in turpis.`,
]

/**
 * Default text separator
 */
export const DEFAULT_TEXT_SEPARATOR = '\n\n'

/**
 * Text words
 */
export const DEFAULT_TEXT_WORDS = [
  ...new Set(words(DEFAULT_TEXT.join('\n').toLowerCase())),
].sort((s1, s2) => s1.length - s2.length || s1.localeCompare(s2))

/**
 * Default markup header
 */
export const DEFAULT_MARKUP_HEADER = `<h1>CHAPTER I.</h1>
<h3><br>Down the Rabbit-Hole</h3>`

/**
 * Default markup paragraphs separator
 */
export const DEFAULT_MARKUP_SEPARATOR = '<p><br></p>'

/**
 * Default markup paragraphs
 */
export const DEFAULT_MARKUP = [
  `<p><strong>Alice</strong> was beginning to get very tired of sitting by
her sister on the bank, and of having nothing to do: once or twice she
had peeped into the book her sister was reading, but it had no pictures
or conversations in it, “and what is the use of a book,” 
thought <strong>Alice</strong> “without pictures or conversations?”</p>`,

  `<p>So she was considering in her own mind (as well as she could, for the
hot day made her feel very sleepy and stupid), whether the pleasure of 
making a daisy-chain would be worth the trouble of getting up and picking 
the daisies, when suddenly a White Rabbit with pink eyes ran close by her.</p>`,

  `<p>There was nothing so <em>very</em> remarkable in that; nor did 
<strong>Alice</strong> think it so <em>very</em> much out of the way to hear
the <strong>Rabbit</strong> say to itself, “Oh dear! Oh dear! I shall be
late!” (when she thought it over afterwards, it occurred to her that she
ought to have wondered at this, but at the time it all seemed quite natural);
but when the <strong>Rabbit</strong> actually <em>took a watch out of its
waistcoat-pocket</em>, and looked at it, and then hurried on,
<strong>Alice</strong> started to her feet, for it flashed across her mind
that she had never before seen a rabbit with either a waistcoat-pocket, or a
watch to take out of it, and burning with curiosity, she ran across the field
after it, and fortunately was just in time to see it pop down a large
rabbit-hole under the hedge.</p>`,
]

/**
 * Max length of the generated values when no limit is given
 */
export const MAX_LENGTH = 2 ** 32 - 1

/**
 * Max length of the generated arrays
 */
export const MAX_ARRAY_LENGTH = 100

/**
 * Max length of the generated strings
 */
export const MAX_STRING_LENGTH = 256

/**
 * Max count of the generated text paragraphs
 */
export const MAX_TEXT_PARAGRAPHS_COUNT = 10
